<div class="dashboard-container" *ngIf="dashboardInfo$ | async as dashboardData">
  <mat-card class="rejection-action-notice" *ngIf="dashboardData.actionRequiredExpenses.length > 0">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <div>
        <mat-card-header>
          <mat-card-title>Action Required</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>You have {{ dashboardData.actionRequiredExpenses.length }} expense(s) currently in the REJECTED status without a specified reason. Please select a reason for the rejections.</p>
        </mat-card-content>
      </div>
      <div>
        <button
          mat-raised-button
          color="primary"
          [routerLink]="['/expenses']"
          [queryParams]="{ ids: dashboardData.actionRequiredExpenses.join(',') }">
          Update Now
        </button>
      </div>
    </div>
  </mat-card>
  <div class="status-tiles-container">
    <div *ngFor="let group of  (dashboardData.groupedStatusCount | sortByStatusOrder: STATUS_GROUPING)"
      class="status-tile"
      [style.background-color]="STATUS_GROUPING[group.key].bg_color"
         [style.color]="STATUS_GROUPING[group.key].text_color">
      <div class="tile-content">
        <p class="tile-header">{{ STATUS_GROUPING[group.key].label }}</p>
        <p class="status-count"><a [routerLink]="['/expenses']" [queryParams]="STATUS_GROUPING[group.key].filter">{{ group.data.total }}</a></p>
      </div>
      <a class="view-details" (click)="viewDetails($event, group.key)">
        View Details
      </a>
      <ul class="status-details" *ngIf="selectedTile === group.key">
        <li *ngFor="let status of group.data.details | sortByStatusOrder: STATUS_MAPPING">
          <span class="status-name"><a [routerLink]="['/expenses']" [queryParams]="{'status' : status.key}">{{ STATUS_MAPPING[parseStatus(status.key)].label }}</a></span>
          <span class="status-value"><a [routerLink]="['/expenses']" [queryParams]="{'status' : status.key}">{{ status.data }}</a></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="adhoc-run-container">
    <p>Adhoc Run</p>
    <div class="adhoc-run-content">
      <div class="adhoc-run-actions" [formGroup]="adhocExpenseProcessRequestForm">
        <div class="first-row">
          <label>Load Latest Banking Information</label>
          <button mat-raised-button color="primary" (click)="runAdhocBankingInfoLoad()">
            RUN NOW
          </button>
        </div>
        <div class="second-row">
          <div>
            <div>
              <label>Process Expense Report</label>
            </div>
            <div class="toggle-question">
              <mat-slide-toggle color="primary" formControlName="extract" (change)="resetConcurExtractToggle($event)">
                Do you want to Load Expense Report from Concur?
              </mat-slide-toggle>
              <ng-container *ngIf="adhocExpenseProcessRequestForm.value['extract']">
                <div class="toggle-question-inner">
                  <mat-slide-toggle color="primary" formControlName="uploadExpenseReport" (change)="resetUploadToggle($event)">
                    Upload Expense Report
                  </mat-slide-toggle>
                  <div *ngIf="adhocExpenseProcessRequestForm.value['uploadExpenseReport']" class="toggle-question-inner">
                    <input type="file" (change)="onFileSelected($event)" />
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="toggle-question">
              <mat-slide-toggle color="primary" formControlName="process">
                Do you want to run the Expense Payment Process?
              </mat-slide-toggle>
            </div>
          </div>
          <div>
            <button
              mat-raised-button
              color="primary"
              (click)="runAdhocExpensesProcessing()"
              [disabled]="(!adhocExpenseProcessRequestForm.value['extract'] && !adhocExpenseProcessRequestForm.value['process'])">
              RUN NOW
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
